export default "__VITE_ASSET__DmkHuV2W__"